/**
 * Makes menu sticky.
 */

import stickybits from 'stickybits';

jQuery( $ => {
	const makeSticky = $( '.secondary-menu-wrapper' ).hasClass( 'sticky-menu' );
	if ( ! makeSticky ) {
		return;
	}
	const offset = $( '#masthead' ).height();
	const stickyArgs = {
		useStickyClasses: true,
		stickyBitStickyOffset: offset,
	};

	// Setting sticky menu offset to the same height as wpadminbar.
	if ( 0 < $( 'body.admin-bar' ).length ) {
		stickyArgs.stickyBitStickyOffset = offset + 32;
	}

	stickybits( '.ac-module-secondary-menu', stickyArgs );
} );
